import React, { useEffect, useState } from "react";
import Layout from "../components/Layout";
import {
    Box,
    Typography,
} from "@mui/material";
import TonesSection from "../components/TonesSection";
import RbtThumbnail from "../assets/Rbt_Thumbnail.jpg";
import SidebarLayout from "../components/Sidebar";
import axios from "axios";
import { useSelector } from "react-redux";
import { RootState } from "../redux/store";


const Dashboard = () => {
   const [rbtCategories , setRbtCategories] = useState<any[]>([]);
//    const registeredName = "John Doe";

    const { countryCode, msisdn } = useSelector(
       (state: RootState) => state.phone
     );
    
    
    const getRbtCategories = async() => {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/Content/ShowCategories?msisdn=${countryCode+msisdn}&service=${process.env.REACT_APP_SERVICE}&interface=${process.env.REACT_APP_INTERFACES}&langId=${process.env.REACT_APP_LANGID}`);
        setRbtCategories(res?.data?.catList.slice(1,3));
    }

    useEffect(() => {
        getRbtCategories();
    },[])

    return (
        <Layout>

            <SidebarLayout>
                <Typography
                    variant="h4"
                    sx={{ color: "#0085CA", mb: 3, pt: 4 }}
                >
                    Welcome 
                    {/* {registeredName} */}
                </Typography>

                <Box
                    sx={{
                        background:
                            "linear-gradient(90deg, #d1d1d1 0%, #f5f5f5 15%, #f5f5f5 85%, #d1d1d1 100%)",
                        boxShadow: "0 4px 25px rgba(0, 0, 0, 0.1)",
                        p: 4,
                        mt: 3,
                        mb: 5,
                        transition: "all 0.3s ease",
                        "&:hover": {
                            boxShadow: "0 8px 30px rgba(0, 0, 0, 0.15)",
                        },
                    }}
                >
                    {
                        rbtCategories.map((item, index) => {
                        return <>
                    <TonesSection title={item?.catName}  categoryId={item?.catId} />
                        </>
                        })
                    }
                 
                </Box>
            </SidebarLayout>
        </Layout>
    );
};

export default Dashboard;
